// Announcement Bar Carousel
document.addEventListener('DOMContentLoaded', function() {
  // Debug log to verify script is running
  console.log('Announcement carousel script loaded');
  
  // Get carousel elements
  const items = document.querySelectorAll('.announcement-carousel .announcement-item');
  const dots = document.querySelectorAll('.announcement-dots .dot');
  
  // Debug log to verify elements are found
  console.log('Found announcement items:', items.length);
  console.log('Found dots:', dots.length);
  
  // Exit if no items found
  if (items.length === 0 || dots.length === 0) {
    console.log('No announcement items or dots found');
    return;
  }
  
  let currentIndex = 0;
  let interval;

  // Initialize the first item as active
  items[0].classList.add('active');
  
  // Function to show a specific announcement
  function showAnnouncement(index) {
    // Remove active class from all items and dots
    items.forEach(item => item.classList.remove('active'));
    dots.forEach(dot => dot.classList.remove('active'));
    
    // Add active class to current item and dot
    items[index].classList.add('active');
    dots[index].classList.add('active');
    
    currentIndex = index;
    console.log('Showing announcement:', index);
  }
  
  // Set up click events for dots
  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      console.log('Dot clicked:', index);
      clearInterval(interval);
      showAnnouncement(index);
      startRotation();
    });
  });
  
  // Function to rotate to the next announcement
  function rotateAnnouncement() {
    let nextIndex = (currentIndex + 1) % items.length;
    showAnnouncement(nextIndex);
  }
  
  // Start the rotation
  function startRotation() {
    // Clear any existing interval first
    if (interval) {
      clearInterval(interval);
    }
    interval = setInterval(rotateAnnouncement, 4000); // Change every 4 seconds
    console.log('Rotation started');
  }
  
  // Initialize rotation
  startRotation();
  
  // Pause rotation when hovering over the announcement bar
  const announcementBar = document.querySelector('.mobile-announcement');
  if (announcementBar) {
    announcementBar.addEventListener('mouseenter', () => {
      clearInterval(interval);
      console.log('Rotation paused');
    });
    
    // Resume rotation when mouse leaves the announcement bar
    announcementBar.addEventListener('mouseleave', () => {
      startRotation();
    });
  }
  
  // Force initial state
  showAnnouncement(0);
});
